import { AddIcon, Button, Dropdown, Input, TimeInput } from "@kart/components";
import { Dispatch, SetStateAction, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { KartType, Session, SessionType } from "../utils/time/time.types";
enum ViewMode {
  SESSION = "SESSION",
  LAP = "LAP",
}
export const SessionPopup: React.FC<{
  sessionToEdit: Session;
  setSessionToEdit: Dispatch<SetStateAction<Session | undefined>>;
  handleSubmit: () => void;
}> = ({ sessionToEdit, setSessionToEdit, handleSubmit }) => {
  const [viewMode, setViewMode] = useState<ViewMode>(ViewMode.SESSION);

  const update = <K extends keyof Session>(
    key: K,
    newValue: Session[K],
  ): void =>
    sessionToEdit && setSessionToEdit({ ...sessionToEdit, [key]: newValue });

  return (
    <form
      className="session-popup"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "fit-content",
      }}
    >
      {viewMode === ViewMode.SESSION ? (
        <div className="session-inputs">
          <Input
            label="Sessionname"
            type="text"
            value={sessionToEdit?.name}
            onChange={(name) => update("name", name)}
          />
          <Input
            type="date"
            onChange={(date) => date && update("date", date)}
            label="Datum"
            value={sessionToEdit?.date}
          />
          <label htmlFor="sessiontype">Sessionart</label>
          <select
            id="sessiontype"
            onChange={(e) => update("type", e.target.value as SessionType)}
          >
            {Object.values(SessionType).map((type) => (
              <option value={type}>{type}</option>
            ))}
          </select>
          <Input
            label="Platz"
            type="number"
            value={sessionToEdit?.position}
            onChange={(position) => update("position", position)}
          />
          <Input
            label="Teilnehmer"
            type="number"
            value={sessionToEdit?.competitors}
            onChange={(competitors) => update("competitors", competitors)}
          />
          <TimeInput
            label="Schnellste Runde"
            ms={sessionToEdit?.fastestLap}
            onChange={(fastestLap) => update("fastestLap", fastestLap)}
          />
          <Input
            type="number"
            label="Gewicht (kg)"
            onChange={(weight) => update("weight", weight)}
            value={sessionToEdit?.weight}
          />
          <Dropdown
            label="Kart"
            options={Object.values(KartType).map((type) => ({
              label: type,
              value: type,
            }))}
            onChange={(kartType) => update("kartType", kartType as KartType)}
          />
          <div
            style={{ display: "flex", gap: "1rem", justifyContent: "center" }}
          >
            <Button
              label="Abbrechen"
              onClick={() => setSessionToEdit(undefined)}
            />
            <Button onClick={() => setViewMode(ViewMode.LAP)} label="weiter" />
          </div>
        </div>
      ) : (
        <div className="session-create__wrapper">
          <Button
            onClick={() =>
              update("laps", [
                ...(sessionToEdit?.laps || []),
                {
                  lapNumber: (sessionToEdit?.laps.length || 0) + 1,
                  id: uuidv4(),
                  lapTime: 0,
                },
              ])
            }
            label={
              <div style={{ display: "flex" }}>
                <p style={{ color: "black" }}>Runde hinzufügen</p>
                <AddIcon style={{ color: "lightgray" }} width={"20px"} />
              </div>
            }
          />

          {sessionToEdit?.laps.map((lap) => (
            <>
              <Input
                value={lap.lapNumber}
                type="number"
                label="Nr."
                onChange={(lapNumber) =>
                  update(
                    "laps",
                    sessionToEdit.laps.map((localLap) =>
                      localLap.id === lap.id ? { ...lap, lapNumber } : localLap,
                    ),
                  )
                }
              />
              <Input
                value={lap.lapTime}
                type="number"
                label="Zeit"
                onChange={(lapTime) =>
                  update(
                    "laps",
                    sessionToEdit.laps.map((localLap) =>
                      localLap.id === lap.id ? { ...lap, lapTime } : localLap,
                    ),
                  )
                }
              />
            </>
          ))}
          <Button
            label="Abbrechen"
            onClick={() => setSessionToEdit(undefined)}
          />
          <Button type="submit" label="Speichern" />
        </div>
      )}
    </form>
  );
};
